import { defineChain, type Address } from 'viem'

/** Robinhood Chain mainnet. */
export const robinhood = defineChain({
  id: 4663,
  name: 'Robinhood Chain',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.mainnet.chain.robinhood.com', 'https://robinhood-rpc.publicnode.com'],
    },
  },
  blockExplorers: {
    default: { name: 'Blockscout', url: 'https://robinhoodchain.blockscout.com' },
  },
})

/** A local anvil fork of Robinhood Chain, used for development and end-to-end tests. */
const localFork = defineChain({
  ...robinhood,
  id: 31337,
  name: 'Robinhood Chain (local fork)',
  rpcUrls: { default: { http: [import.meta.env.VITE_RPC_URL ?? 'http://127.0.0.1:8545'] } },
})

const isLocal = import.meta.env.VITE_CHAIN === 'local'

export const chain = isLocal ? localFork : robinhood

/** The $WIF token (World is Flat) on Robinhood Chain. */
export const WIF: Address = '0x5173b8eA6923c2d40267890D45C46a3480954773'

/**
 * The deployed Flatboard contract and the block it was deployed in.
 * Filled in after deployment; VITE_FLATBOARD / VITE_DEPLOY_BLOCK override them for local runs.
 */
const DEPLOYED = {
  address: '' as Address | '',
  block: 0n,
}

export const FLATBOARD = (import.meta.env.VITE_FLATBOARD ?? DEPLOYED.address) as Address | ''
export const DEPLOY_BLOCK = BigInt(import.meta.env.VITE_DEPLOY_BLOCK ?? DEPLOYED.block)

export const MIN_LIST_BURN = 50n * 10n ** 18n
export const MIN_BOOST_BURN = 10n * 10n ** 18n
export const HALF_LIFE = 86_400n

export const REPO_URL = 'https://github.com/tipusultan287/flatboard'
export const SITE_URL = 'https://tipusultan287.github.io/flatboard/'

export const explorerTx = (hash: string) => `${chain.blockExplorers.default.url}/tx/${hash}`
export const explorerAddress = (address: string) => `${chain.blockExplorers.default.url}/address/${address}`
